import { FormHelperText as MuiFormHelperText, styled } from "@mui/material";

export const FormHelperText = styled(MuiFormHelperText)({
  marginLeft: 0,
});
